import React from 'react';
import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';
import { PaymentForm as PaymentModel } from '@models/MLTC/Payment.model';
import { Helpers } from '@utils/helpers';
import ContainerBlock from '@components/ContainerBlock';
import Text from '@components/Text';
import Heading from '@components/Heading';
import Input from '@components/Input';
import Dropdown from '@components/Dropdown';
import Divider from '@components/Divider';
import Checkbox from '@components/Checkbox';
import { IErrors } from '@utils/useForm';
import Bullet from '@components/Bullet';
import { isEmpty } from 'lodash';
import { useAvivaSelector } from '@redux/hook';
import CheckboxList from '@components/CheckboxList';
import { validate } from '../../service';
import InformationBox from '@components/InformationBox';
import Link from '@components/Link';

const BoldText = styled.span<{ color: string }>`
  font-weight: 600;
  color: ${prop => prop.color};
`

export interface PaymentFormProps {
  errors: IErrors,
  handleChange: (e: any) => void,
  values: PaymentModel,
  premium: number

}

function PaymentForm({ errors, handleChange, values, premium }: PaymentFormProps) {
  const theme: ITheme = useTheme();
  const banks = useAvivaSelector(state => state.staticData.banks);


  return (
    <>
      <ContainerBlock paddingTablet="30px 30px 30px" padding="38px 20px 30px" margin={0} marginTablet={0} background={theme.colors.grey[200]}>
        <Heading variant="sub">Credit Card payment details</Heading>
        <Divider size={1} margin="0 0 30px" />
        <Text margin="0 0 30px" fontSize={theme.fontSize.smallTitle} fontWeight={300}>
          Total amount outstanding: <BoldText color={theme.colors.grey[300]}>{Helpers.toCurrency(premium)}</BoldText>
        </Text>
        <Heading variant="label">Card holder&apos;s name</Heading>
        {!errors?.name?.isValid && errors?.name?.message && <Bullet variant="error">{errors?.name?.message}</Bullet>}
        <Input margin="0 0 30px" name="name" type="alphanumeric" invalid={!isEmpty(errors?.name?.message)} value={values['name']} maxLength={30} onChange={handleChange} />
        <Heading variant="label">Card holder&apos;s NRIC/FIN</Heading>
        <Input margin="0 0 30px" disabled name="no" value={values['no']} />
        <Heading variant="label">Credit card issuing bank</Heading>
        <Dropdown source={banks} bindLabel="description" bindId="code" name="bank" value={values['bank']} onChange={handleChange} placeholder="Please select" margin="0 0 30px" />
        {values['bank'] === '11' && (
          <React.Fragment>
            <Heading variant="label"> Others </Heading>
            {!errors.others.isValid && errors.others.message && <Bullet variant="error">{errors.others.message}</Bullet>}
            <Input name="others" value={values['others']} invalid={!isEmpty(errors.others.message)} onChange={handleChange} maxLength={30} />
          </React.Fragment>
        )}
        <CheckboxList margin={0}>
          <Checkbox checked={values['isAuthorised']} name="isAuthorised" onChange={handleChange}><Text>I authorise Singapore Life Ltd. to charge the <b>initial and subsequent</b> premium(s) to my credit card account for this insurance policy.</Text></Checkbox>
        </CheckboxList>
        
      </ContainerBlock>
    </>

  );
};

export default PaymentForm;
